/** Local Creators profile UI wrappers around shared turnaround helpers. */
import {
  encodeTurnaroundCustom,
  formatTurnaroundLabel,
  isTurnaroundCustomEncoded,
  isTurnaroundPreset,
  isTurnaroundSelectionComplete,
  isValidTurnaroundTime,
  normalizeTurnaroundTime,
  parseTurnaroundCustom,
  type TurnaroundCustomParts,
} from '@foodfluence/shared';

export {
  encodeTurnaroundCustom,
  formatTurnaroundLabel,
  isTurnaroundCustomEncoded,
  isTurnaroundPreset,
  isTurnaroundSelectionComplete,
  isValidTurnaroundTime,
  normalizeTurnaroundTime,
  parseTurnaroundCustom,
  type TurnaroundCustomParts,
};

export function isTurnaroundOtherUi(value: string | null | undefined): boolean {
  if (!value) return false;
  if (value === 'other') return true;
  // Presets like `1w` match the custom regex, but should not show the "Other" UI.
  if (isTurnaroundPreset(value)) return false;
  return isTurnaroundCustomEncoded(value);
}
